export interface FollowForm {
  email: string
}

export const initialFollowForm: FollowForm = { email: '' }
